var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIconsHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.567,
    height: 12.822,
    viewBox: "0 0 14.567 12.822",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,15.4V11.548h3.167V15.4a.783.783,0,0,0,.792.77h2.375a.783.783,0,0,0,.792-.77V10.008h1.346a.381.381,0,0,0,.261-.67l-6.618-5.8a.815.815,0,0,0-1.061,0l-6.618,5.8a.382.382,0,0,0,.261.67H4.542V15.4a.783.783,0,0,0,.792.77H7.709A.783.783,0,0,0,8.5,15.4Z",
    transform: "translate(-2.802 -3.345)",
    fill: "#888075"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconsHome);
export default __webpack_public_path__ + "static/media/navIcons_Home.01dbcd71.svg";
export { ForwardRef as ReactComponent };